/* ==========================================================================
   RYSE · a bolsa
   ==========================================================================
   PARTE 1 . O BARRAMENTO
   --------------------------------------------------------------------------
   O PROBLEMA MEDIDO: ao adicionar pela PDP, a bolha do icone continuava no
   numero velho CINCO SEGUNDOS depois. Nenhum evento de carrinho era disparado
   por ninguem. Nao era demora: era fio solto - a bolha so acordava em
   recarregamento de pagina.

   Escutar o evento do tema nao resolve: cada versao do Horizon anuncia a
   adicao de um jeito, e app de terceiro nao anuncia de jeito nenhum. Entao a
   pergunta muda de "quem avisa?" para "quem escreve?" - e quem escreve sempre
   passa pelo mesmo cano, o fetch.

   --------------------------------------------------------------------------
   E A SEGUNDA DEMORA ERA MINHA

   A primeira versao deste barramento, ao ver uma escrita, ia perguntar
   /cart.js. Medido na rede real: o /cart/add.js levava ~815ms e a minha
   pergunta somava outros ~650ms - quase dois segundos ate a bolha se mexer,
   sendo que 40% disso era um pedido que nao precisava existir.

   Nao precisava porque A PROPRIA RESPOSTA DA ESCRITA JA TRAZ O DADO:
     /cart/change|update|clear.js  ->  o carrinho INTEIRO (tem item_count)
     /cart/add.js                  ->  a linha adicionada (tem quantity,
                                       product_title, variant_title, image)

   Entao agora:
     . change/update/clear: publica direto da resposta. Zero pedido extra.
     . add: publica na hora {delta, item} - a bolha anda E o aviso aparece
       assim que o add responde - e SO ENTAO busca o carrinho inteiro pra
       completar o que falta (o total, que o add nao devolve e de que a barra
       flutuante precisa).

   O `item` vem de GRACA: ele ja estava na resposta que a gente ignorava.

   O delta tambem nao e chute otimista: e a quantidade CONFIRMADA. Continuo
   sem mentir antes da resposta - so parei de perguntar duas vezes a mesma
   coisa.

   DOIS CUIDADOS QUE PARECEM DETALHE E NAO SAO:
   . a resposta e lida em res.clone(). Corpo de resposta so pode ser lido uma
     vez - consumir o original deixaria quem chamou sem nada;
   . o /cart.js de reforco usa o fetch ORIGINAL guardado. Usar o embrulhado
     seria uma chamada dentro do gatilho dela mesma.

   A ORDEM DOS TESTES IMPORTA: change/update tambem devolvem `items`, mas
   devolvem `item_count` junto. Por isso item_count e testado PRIMEIRO - se
   nao fosse, uma remocao seria lida como adicao e o aviso apareceria dizendo
   que entrou o que acabou de sair.
   ========================================================================== */
(function () {
  if (window.__ryseBus) return;
  window.__ryseBus = true;

  var ESCRITA = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var puro = window.fetch.bind(window);

  function publica(detalhe) {
    document.dispatchEvent(new CustomEvent('ryse:carrinho', { detail: detalhe, bubbles: true }));
  }

  function buscaInteiro() {
    puro('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(publica)
      .catch(function () {});
  }

  function leResposta(res) {
    res.json().then(function (j) {
      if (!j) return buscaInteiro();

      if (typeof j.item_count === 'number') { publica(j); return; }        // carrinho inteiro

      if (Array.isArray(j.items)) {                                        // add de varios
        var soma = j.items.reduce(function (a, x) { return a + (x.quantity || 0); }, 0);
        publica({ delta: soma, item: j.items[0] });
        buscaInteiro(); return;
      }
      if (typeof j.quantity === 'number') {                                // add de um
        publica({ delta: j.quantity, item: j });
        buscaInteiro(); return;
      }
      buscaInteiro();
    }).catch(buscaInteiro);
  }

  window.fetch = function () {
    var url = String((arguments[0] && arguments[0].url) || arguments[0] || '');
    var p = puro.apply(null, arguments);
    if (!ESCRITA.test(url)) return p;
    return p.then(function (res) {
      if (res.ok) { try { leResposta(res.clone()); } catch (e) { buscaInteiro(); } }
      return res;
    });
  };

  /* app antigo ainda usa XMLHttpRequest - o cano e outro, o anuncio e o mesmo. */
  var abrir = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    if (ESCRITA.test(String(u || ''))) {
      this.addEventListener('load', function () { if (this.status < 400) buscaInteiro(); });
    }
    return abrir.apply(this, arguments);
  };
})();

/* ==========================================================================
   PARTE 2 . O PAINEL E O AVISO
   --------------------------------------------------------------------------
   O JS AQUI NAO FORMATA DINHEIRO E NAO MONTA HTML DE ITEM. Ele abre e fecha o
   painel, manda a mudanca de quantidade pro Shopify, poe um add-on e pede a
   MARCACAO NOVA de volta pela Section Rendering API. Quem desenha e o Liquid.

   Por que: formatar moeda no cliente e como se perde centavo. O filtro `money`
   conhece a moeda da loja, o separador decimal e a posicao do simbolo; um
   toFixed(2) no navegador nao conhece nenhum dos tres.
   ========================================================================== */
(function () {
  if (window.__ryseCar) return;
  window.__ryseCar = true;

  var ocupado = false;
  var contagem = null;

  function painel() { return document.querySelector('[data-rcar]'); }
  function botao() { return document.querySelector('.rtools [aria-controls="rcar"]'); }

  /* o id da secao sai do proprio DOM: ele carrega o numero do tema e muda
     quando a secao e recriada. Escrever no codigo e garantir que quebra. */
  function secaoId() {
    var p = painel();
    var s = p && p.closest('.shopify-section');
    return s ? s.id.replace('shopify-section-', '') : null;
  }

  function fechaMenu() {
    var m = document.getElementById('rmn');
    if (m) m.classList.remove('on');
    var b = document.querySelector('.rburg');
    if (b) { b.classList.remove('on'); b.setAttribute('aria-expanded', 'false'); }
  }

  /* ==========================================================================
     A CLASSE NO <BODY> E O QUE TIRA A BARRA FLUTUANTE DO CAMINHO
     --------------------------------------------------------------------------
     Medido numa tela de 932px com a bolsa cheia: a barra ocupa 854->932 e o
     teto do painel e 909. Ela cobre os ultimos 55px do painel - exatamente
     onde mora o "Finalizar a compra". O botao de comprar embaixo de outro
     botao de comprar.

     A regra visual mora no CSS (ryse-carrinho-extra.css); aqui so vai o
     interruptor. Daria pra dispensar este JS inteiro com body:has(.rcar.on),
     mas :has() so chegou no Firefox na 121 - e o modo de falhar aqui nao e
     cosmetico, e o CTA coberto. Duas linhas de JS compram essa certeza.
     ========================================================================== */
  function abre() {
    var p = painel(); if (!p) return;
    fechaMenu();
    escondeAviso();          // o painel mostra tudo o que o aviso mostrava, e mais
    p.classList.add('on');
    p.setAttribute('aria-hidden', 'false');
    document.body.classList.add('rcar-on');
    var b = botao(); if (b) b.setAttribute('aria-expanded', 'true');
    atualiza();
  }

  function fecha() {
    var p = painel(); if (!p) return;
    p.classList.remove('on');
    p.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('rcar-on');
    var b = botao(); if (b) b.setAttribute('aria-expanded', 'false');
  }

  function aberto() {
    var p = painel();
    return !!p && p.classList.contains('on');
  }

  /* ---- troca o painel pela versao que o servidor acabou de desenhar ---- */
  function atualiza() {
    var id = secaoId(); if (!id) return Promise.resolve();
    return fetch(location.pathname + '?section_id=' + encodeURIComponent(id), { cache: 'no-store' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var novo = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-rcar]');
        var velho = painel();
        if (!novo || !velho) return;
        /* o estado de aberto e do NAVEGADOR, nao do servidor: preserva antes
           de trocar, senao o painel some no meio do uso.
           (O aviso e a classe do <body> nao precisam disso: vivem FORA do
           [data-rcar] e por isso sobrevivem a troca - foi de proposito.) */
        if (velho.classList.contains('on')) novo.classList.add('on');
        novo.setAttribute('aria-hidden', velho.getAttribute('aria-hidden') || 'true');
        velho.replaceWith(novo);
      })
      .catch(function () { /* rede caiu: fica com o que ja estava na tela */ });
  }

  /* ==========================================================================
     A BOLHA E O AVISO - DUAS RESPOSTAS, DOIS TRABALHOS
     --------------------------------------------------------------------------
     Numa colecao ou na home nao ha barra flutuante pra confirmar nada: o
     produto entra e a pagina fica igual. Por isso o movimento aqui nao e
     enfeite - e a resposta.

     A BOLHA diz QUANTOS: a sacola encolhe e volta (o objeto cedendo ao peso),
     a bolha salta de 0.4 a 1.22 e assenta em 1 (o exagero no meio e o que faz
     um numero de 8px ser notado no canto da tela).

     O AVISO diz O QUE e PRA ONDE FOI. Nasce sob o icone, entao a posicao ja
     responde "foi pra bolsa" antes de o texto ser lido.

     SO ANIMA QUANDO O NUMERO MUDA. A bolha e re-sincronizada em varias
     ocasioes; animar em todas transformaria a confirmacao em tique nervoso.
     ========================================================================== */
  function pintaBolha(n) {
    var mudou = contagem !== null && n !== contagem;
    contagem = n;

    document.querySelectorAll('[data-rbag]').forEach(function (b) {
      b.dataset.n = n;
      b.textContent = n > 0 ? n : '';
      if (!mudou || n === 0) return;
      /* reiniciar animacao pede remover a classe, FORCAR reflow e por de
         volta. Sem o reflow o navegador junta as duas escritas num quadro so
         e a animacao nao recomeca. */
      b.classList.remove('pulou');
      void b.offsetWidth;
      b.classList.add('pulou');

      var t = b.closest('.rtool');
      if (t) { t.classList.remove('recebeu'); void t.offsetWidth; t.classList.add('recebeu'); }
    });
  }

  /* ---- o aviso ----
     VIDA de 3,6s. Nao ha botao de fechar - um X num cartao que ja some sozinho
     so adiciona um alvo pequeno e uma decisao que ninguem precisa tomar.
     O RELOGIO PAUSA no hover e no foco: aviso que foge enquanto a pessoa le e
     pior que aviso nenhum. */
  var AVISO_VIDA = 3600;
  var aviTimer = null;

  function avi() { return document.querySelector('[data-ravi]'); }

  /* a resposta do add traz a URL do arquivo original, que pode ter 2000px. O
     cartao mostra 44. Sem o parametro, a pagina baixa a foto inteira pra
     desenhar um quadrado. */
  function miniatura(u) {
    try {
      var x = new URL(u, location.origin);
      x.searchParams.set('width', '120');
      return x.href;
    } catch (e) { return u; }
  }

  function relogio() {
    clearTimeout(aviTimer);
    aviTimer = setTimeout(escondeAviso, AVISO_VIDA);
  }

  function escondeAviso() {
    clearTimeout(aviTimer);
    var el = avi(); if (el) el.dataset.on = '0';
  }

  function mostraAviso(item) {
    var el = avi(); if (!el || !item) return;
    if (aberto()) return;      // o painel ja diz tudo isso, e melhor

    var nome = item.product_title || item.title || '';
    var vari = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var linha = vari ? nome + ' · ' + vari : nome;

    var img = el.querySelector('[data-ravi-img]');
    if (img) {
      var u = item.image || (item.featured_image && item.featured_image.url) || '';
      img.style.backgroundImage = u ? 'url("' + miniatura(u) + '")' : '';
    }

    var nm = el.querySelector('[data-ravi-nm]');
    if (nm) nm.textContent = linha;

    /* dois avisos seguidos NAO empilham: o segundo troca o conteudo no lugar e
       reinicia o relogio. Empilhar sob um icone de 19px seria uma pilha mais
       alta que a coisa a que ela se refere. */
    var sr = document.querySelector('[data-ravi-sr]');
    if (sr) sr.textContent = 'Adicionado à bolsa: ' + linha;

    el.dataset.on = '1';
    relogio();
  }

  /* o aviso vive FORA do [data-rcar], entao nunca e substituido: da pra
     prender os ouvintes nele de uma vez, sem delegacao. */
  function ligaAviso() {
    var el = avi();
    if (!el || el.dataset.ligado) return;
    el.dataset.ligado = '1';
    el.addEventListener('mouseenter', function () { clearTimeout(aviTimer); });
    el.addEventListener('focusin', function () { clearTimeout(aviTimer); });
    el.addEventListener('mouseleave', function () { if (el.dataset.on === '1') relogio(); });
    el.addEventListener('focusout', function () { if (el.dataset.on === '1') relogio(); });
  }

  /* ---- mudar quantidade ----
     line e a POSICAO na bolsa (1, 2, 3...), nao o id da variante. Com id, um
     produto que esta na bolsa duas vezes com descontos diferentes vira uma
     linha so na hora de mexer - e a pessoa perde o item errado. */
  function mexe(linha, quantidade) {
    if (ocupado) return;
    ocupado = true;
    var p = painel(); if (p) p.classList.add('ocupado');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: linha, quantity: quantidade })
    })
      .then(function () { return atualiza(); })
      .catch(function () {})
      .then(function () {
        ocupado = false;
        var q = painel(); if (q) q.classList.remove('ocupado');
      });
  }

  /* ---- por um add-on ----
     MESMO GUARDA DO STEPPER (ocupado): dois cliques rapidos no mesmo cartao
     mandariam dois pedidos, e o segundo chegaria com a bolsa velha.

     E CHAMA atualiza() EM VEZ DE ESPERAR O BARRAMENTO, de proposito. O
     barramento vai anunciar de qualquer jeito - mas o painel esta ABERTO na
     frente da pessoa, e ela precisa ver o item entrar na lista e o cartao sair
     da fila. Esperar o carrinho inteiro voltar custaria ~650ms de tela parada
     logo depois de um clique. */
  function poe(vid) {
    if (!vid || ocupado) return;
    ocupado = true;
    var p = painel(); if (p) p.classList.add('ocupado');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function () { return atualiza(); })
      .catch(function () {})
      .then(function () {
        ocupado = false;
        var q = painel(); if (q) q.classList.remove('ocupado');
      });
  }

  function qtdAtual(linha) {
    var it = document.querySelector('.rcar__it[data-linha="' + linha + '"] .rcar__step span');
    return it ? parseInt(it.textContent, 10) || 1 : 1;
  }

  /* ---- eventos, todos delegados no documento ----
     O painel inteiro e substituido a cada mudanca: listener preso a um botao
     morreria no primeiro clique. */
  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-ravi-abre]')) { e.preventDefault(); abre(); return; }

    if (t.closest('[aria-controls="rcar"]')) {
      e.preventDefault();
      if (aberto()) fecha(); else abre();
      return;
    }
    if (t.closest('[data-rcar-fecha]')) { fecha(); return; }

    var add = t.closest('[data-rcar-poe]');
    if (add) { poe(+add.dataset.rcarPoe); return; }

    var mais = t.closest('[data-rcar-mais]');
    if (mais) { var lm = +mais.dataset.rcarMais; mexe(lm, qtdAtual(lm) + 1); return; }

    var menos = t.closest('[data-rcar-menos]');
    if (menos) { var ln = +menos.dataset.rcarMenos; mexe(ln, Math.max(0, qtdAtual(ln) - 1)); return; }

    var tira = t.closest('[data-rcar-tira]');
    if (tira) { mexe(+tira.dataset.rcarTira, 0); return; }

    if (t.closest('.rburg')) { escondeAviso(); if (aberto()) fecha(); return; }

    /* clique fora fecha - mas nao o clique no proprio header, senao o botao
       do carrinho fecharia e reabriria no mesmo toque */
    if (aberto() && !t.closest('[data-rcar]') && !t.closest('.rhb')) fecha();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (aberto()) {
      fecha();
      var b = botao(); if (b) b.focus();
      return;
    }
    escondeAviso();   // Esc tambem dispensa o aviso, sem precisar acerta-lo
  });

  /* o barramento e a unica fonte. Ele manda dois formatos:
       {item_count, ...}     o carrinho inteiro
       {delta, item}         "entraram n, e foi este" - o aviso rapido do add */
  document.addEventListener('ryse:carrinho', function (e) {
    var c = e.detail; if (!c) return;

    if (typeof c.item_count === 'number') {
      pintaBolha(c.item_count);
      if (aberto()) atualiza();
      return;
    }
    if (typeof c.delta === 'number') {
      if (contagem !== null) pintaBolha(contagem + c.delta);
      if (c.item) mostraAviso(c.item);
    }
  });

  function primeiraLeitura() {
    var b = document.querySelector('[data-rbag]');
    contagem = b ? (parseInt(b.dataset.n, 10) || 0) : 0;
    ligaAviso();
    /* a secao pode ser recriada pelo editor com o painel fechado enquanto o
       <body> ainda carrega a classe de aberto - a barra ficaria escondida sem
       nada na frente dela */
    if (!aberto()) document.body.classList.remove('rcar-on');
  }
  if (document.readyState !== 'loading') primeiraLeitura();
  else document.addEventListener('DOMContentLoaded', primeiraLeitura);
  document.addEventListener('shopify:section:load', primeiraLeitura);
})();

/* ==========================================================================
   PARTE 3 . O FUNIL (05/10/2026, pedido do trafego pago)
   --------------------------------------------------------------------------
   O debug do GA mostrava o checkout inteiro e a compra, mas NADA no momento
   em que a pessoa sai da loja pro checkout - a passagem entre os dois sites.

   Dois eventos fecham o funil:
     view_cart          quando a bolsa abre (e na pagina /cart)
     InitiateCheckout   no gesto de "Finalizar compra", antes de sair da loja

   O NOME E InitiateCheckout NOS DOIS - Google E Meta (pedido do trafego,
   05/10). NAO e begin_checkout: no funil da Mey's o begin_checkout ja e
   disparado DENTRO do checkout, quando a pessoa comeca a preencher. Usar o
   mesmo nome aqui misturaria "clicou em finalizar" com "comecou a preencher"
   - justamente a passagem que o evento existe pra separar. E o nome bate
   com o evento padrao da Meta.

   PRA ONDE VAO:
     gtag     -> GA4 (G-T5TF1SKYMP) e Google Ads   evento "InitiateCheckout"
     fbq      -> os dois pixels da Meta na pagina  evento padrao InitiateCheckout
     ttq      -> TikTok                            InitiateCheckout
     dataLayer-> ryse_initiate_checkout / ryse_view_cart (nome proprio pro
                 GTM, pra nenhuma tag existente duplicar)
   O mesmo event_id vai pra Meta e TikTok (dedup com API de conversoes).

   --------------------------------------------------------------------------
   O CHECKOUT DA MEY'S E EXTERNO: AZIRT (seguro.meys.com.br).

   O script da AZIRT (loader.js, no ryse-stack-medicao) pega o clique no
   /checkout e leva a pessoa pro checkout dela. REGRA: este codigo NUNCA mexe
   na navegacao - nada de preventDefault, nada de location. (A primeira
   versao fazia isso e jogava a pessoa no checkout nativo da Shopify,
   passando por cima da AZIRT. Corrigido em 05/10.)

   E POR ISSO O EVENTO SAI NO TOQUE, NAO NO CLIQUE. Disparado no `click`, ele
   corria contra a AZIRT: ela navega no mesmo clique, e o pixel da Meta (que
   manda o hit como imagem, depois de processar) era cancelado pela troca de
   pagina - o trafego viu o view_cart chegar e o Initiate nao. O `pointerdown`
   (dedo encostou / botao do mouse desceu) acontece ANTES do click - no
   celular, 80 a 300ms antes - e da ao pixel esse tempo de sair. O click fica
   de rede de seguranca (teclado, leitor de tela); a trava de 3s impede o
   evento duplo quando os dois acontecem.

   O CARRINHO TEM DE ESTAR LIDO ANTES DO TOQUE: e lido quando a pagina abre
   com algo na bolsa, quando a bolsa abre, e a cada mudanca que o barramento
   anuncia.

   QUEM MEXER AQUI: teste tocando em "Finalizar compra" e confira (1) que a
   URL final e seguro.meys.com.br e (2) o InitiateCheckout no Pixel Helper /
   Events Manager e no DebugView do GA.

   O item_id segue o formato do app Google da Shopify (shopify_BR_produto_
   variante) - assim o GA casa o produto do clique com o da compra.
   ========================================================================== */
(function () {
  if (window.__ryseFunil) return;
  window.__ryseFunil = true;

  var cache = null;
  document.addEventListener('ryse:carrinho', function (e) {
    var c = e.detail;
    if (c && typeof c.item_count === 'number' && Array.isArray(c.items)) cache = c;
  });

  /* le o carrinho com teto: passou do teto, segue com o que tiver */
  function carrinho(teto) {
    return new Promise(function (ok) {
      var feito = false;
      function fim(c) { if (!feito) { feito = true; ok(c); } }
      setTimeout(function () { fim(cache); }, teto);
      fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { cache = c; fim(c); })
        .catch(function () { fim(cache); });
    });
  }

  function itensGa(c) {
    return (c.items || []).map(function (it, i) {
      var o = { item_id: 'shopify_BR_' + it.product_id + '_' + it.variant_id, item_name: it.product_title, item_brand: "Mey's", price: it.final_price / 100, quantity: it.quantity, index: i };
      if (it.variant_title && it.variant_title !== 'Default Title') o.item_variant = it.variant_title;
      return o;
    });
  }
  function cupom(c) { var d = (c.cart_level_discount_applications || [])[0]; return d ? d.title : undefined; }
  function novoId() { return 'ryse-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8); }

  function viewCart(c) {
    if (!c || !c.item_count) return;
    var moeda = c.currency || 'BRL', v = c.total_price / 100, its = itensGa(c);
    try { if (typeof window.gtag === 'function') window.gtag('event', 'view_cart', { currency: moeda, value: v, items: its }); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'ryse_view_cart', ecommerce: { currency: moeda, value: v, items: its } }); } catch (e) {}
  }

  var ultimo = 0;
  function initiate(c) {
    if (!c || !c.item_count) return;
    if (Date.now() - ultimo < 3000) return;      // toque + clique contam uma vez so
    ultimo = Date.now();
    var moeda = c.currency || 'BRL', v = c.total_price / 100, its = itensGa(c), ev = novoId(), cp = cupom(c);
    var ids = c.items.map(function (it) { return String(it.variant_id); });
    try {
      if (typeof window.fbq === 'function') window.fbq('track', 'InitiateCheckout', {
        value: v, currency: moeda, content_type: 'product', num_items: c.item_count, content_ids: ids
      }, { eventID: ev });
    } catch (e) {}
    try {
      if (typeof window.gtag === 'function') {
        var g = { currency: moeda, value: v, items: its, transport_type: 'beacon' };
        if (cp) g.coupon = cp;
        window.gtag('event', 'InitiateCheckout', g);
      }
    } catch (e) {}
    try {
      if (window.ttq && typeof window.ttq.track === 'function') window.ttq.track('InitiateCheckout', {
        value: v, currency: moeda,
        contents: c.items.map(function (it) { return { content_id: String(it.variant_id), content_name: it.product_title, quantity: it.quantity, price: it.final_price / 100 }; })
      }, { event_id: ev });
    } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: 'ryse_initiate_checkout', event_id: ev, ecommerce: { currency: moeda, value: v, coupon: cp, items: its } }); } catch (e) {}
  }

  /* toda saida pro checkout: o botao da bolsa, o da pagina /cart e qualquer
     link direto. So ESCUTA - nunca preventDefault, nunca navega. */
  var SAIDA = 'a[href*="/checkout"], [data-cart-checkout], button[name="checkout"], input[name="checkout"]';
  function gesto(e) {
    var a = e.target && e.target.closest && e.target.closest(SAIDA);
    if (!a) return;
    if (cache && cache.item_count) initiate(cache);
    else carrinho(1500).then(initiate);
  }
  document.addEventListener('pointerdown', gesto, { capture: true, passive: true });
  document.addEventListener('click', gesto, true);

  function liga() {
    var aberta = document.body.classList.contains('rcar-on');
    new MutationObserver(function () {
      var on = document.body.classList.contains('rcar-on');
      if (on && !aberta) carrinho(2000).then(viewCart);
      aberta = on;
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
    if (/^\/cart\/?$/.test(location.pathname)) carrinho(2000).then(viewCart);
    /* bolsa com algo dentro: deixa o carrinho lido antes do primeiro toque */
    else {
      var b = document.querySelector('[data-rbag]');
      if (b && parseInt(b.dataset.n, 10) > 0) carrinho(3000);
    }
  }
  if (document.readyState !== 'loading') liga();
  else document.addEventListener('DOMContentLoaded', liga);
})();
